import {useEffect, useState} from "react";
import {List, Card, Button, Space, Typography} from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import ApiService from "../../core/service/api-service";
import {t} from "i18next";

export default function ReportTemplateSorter({reportTemplateId, reqTypeId, onSaved}) {
    const [data, setData] = useState([]);

    const getTemplates = async () => {
        const res = await ApiService.ReportTemplate.GetListByRequestType(reqTypeId);
        if(res.success) {
            setData(res.data);
        }
    }

    useEffect(() => {
        if(reportTemplateId) {
            getTemplates();
        }
    }, [reportTemplateId])

    const moveItem = (index, direction) => {
        const newData = [...data];
        const targetIndex = index + direction;
        if (targetIndex < 0 || targetIndex >= newData.length) return;
        // Swap items
        [newData[index], newData[targetIndex]] = [newData[targetIndex], newData[index]];
        // Update sortColumn: highest at top
        const maxSort = newData.length - 1;
        const updated = newData.map((item, idx) => ({
            ...item,
            sortColumn: maxSort - idx
        }));
        setData(updated);
        // Optionally, send updated order to backend here
    };

    const save = async () => {
        const res = await ApiService.ReportTemplate.SaveReportTemplateSort({
            sortItems: data.map(x => ({
                reportTemplateId: x.id,
                sortColumn: x.sortColumn
            }))
        });

        if(res.success) {
            onSaved && onSaved();
        }
    }

    return (
        <div>
            <List
                dataSource={data}
                size={'small'}
                renderItem={(item, idx) => (
                    <List.Item
                        actions={[

                        ]}
                    >
                        <Space>
                            <Button
                                icon={<ArrowUpOutlined />}
                                onClick={() => moveItem(idx, -1)}
                                disabled={idx === 0}
                                size="small"
                            />
                            <Button
                                icon={<ArrowDownOutlined />}
                                onClick={() => moveItem(idx, 1)}
                                disabled={idx === data.length - 1}
                                size="small"
                            />
                            <b>{item.name}</b>
                        </Space>
                    </List.Item>
                )}
            />

            <Button
                style={{marginTop: 24, marginLeft: 12}}
                size={'small'}
                type={'primary'}
                onClick={save}
            >
                {t('Save')}
            </Button>
        </div>
    )
}